import React from 'react';

import { FormField } from 'fr-shared/components';

const FormFastField = props => {
  return <FormField fastField={true} {...props} />;
};

export default FormFastField;
